import { exists } from '../base/dom-utils.js';
import Analytics from '../base/wyn-analytics-module.js';

class ContentModule {
  constructor() {
    if (exists('.content-module-component')) {
      this.bindLinkClick();
    }
  }

  bindLinkClick() {
    $('.content-module-component a').click((e) => {
      Analytics.getContentModuleInfo(e.currentTarget);
      //"dynamicoffershownClick" Event Activation Point - Push Adobe Digital Data onclick of Dynamic offer content link on Search Result page.
      window.AdobeWebSdk && window.AdobeWebSdk.onClickDynamicOfferContentSRPPage(e.target);
      //"postsigninregisterbuttonClicks" Event Activation Point - Push Adobe Digital Data On Click Of Register Now Button in Deals Page.
      window.AdobeWebSdk && window.AdobeWebSdk.postsigninregisterbuttonClicksOnDealsPage(e.currentTarget);
    });
  }
}

export default new ContentModule();
